<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div class="mb-6 border-t-2 border-s-200">
    <h2
      class="-mt-px inline-block bg-p-400 px-2 py-1 text-base font-semibold text-black"
    >
      {{ title }}
    </h2>
  </div>
</template>
